export enum EMargin {
    None = 'None',
    M1 = 'M1',
    M2 = 'M2',
    M3 = 'M3',
    M4 = 'M4',
    M5 = 'M5',
    M6 = 'M6',
    M7 = 'M7',
    M8 = 'M8',
    M9 = 'M9',
    M10 = 'M10',
    M11 = 'M11',
    M12 = 'M12',
    M13 = 'M13',
    M14 = 'M14',
    M15 = 'M15',
    M16 = 'M16',
    M17 = 'M17',
    M18 = 'M18',
    M19 = 'M19',
    M20 = 'M20',
    M21 = 'M21',
    M22 = 'M22',
    M23 = 'M23',
    M24 = 'M24',
    M25 = 'M25'
}